<template>
  <button
    class="menu-options__button"
    :class="{'menu-options__button--active' : isSearchOpen}"
    @click.stop="toggle"
  >
    <SearchSVG />
  </button>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import SearchSVG from '@/components/svg/SearchSVG'

  export default {
    components: {
      SearchSVG,
    },

    computed: {
      ...mapGetters('app', ['isSearchOpen']),
    },

    methods: {
      ...mapMutations('app', ['setSearchVisibility']),

      toggle () {
        this.setSearchVisibility(!this.isSearchOpen)
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep svg { width: 16px!important }
</style>